// 11sight added line
import { THIRD_PARTY_PREJOIN_BUTTONS } from 'config/constants';
import clsx from 'clsx';
import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import DeviceStatus from 'jitsi/prejoin/components/web/preview/DeviceStatus';
import Toolbox from 'jitsi/toolbox/components/web/Toolbox';
import { getConferenceName } from 'jitsi/base/conference/functions';
import { PREMEETING_BUTTONS } from 'jitsi/base/config/constants';
import { getToolbarButtons, isToolbarButtonEnabled } from 'jitsi/base/config/functions.web';
import { withPixelLineHeight } from 'jitsi/base/styles/functions.web';
import ConnectionStatus from 'jitsi/base/premeeting/components/web/ConnectionStatus';
import Preview from 'jitsi/base/premeeting/components/web/Preview';
import UnsafeRoomWarning from 'jitsi/base/premeeting/components/web/UnsafeRoomWarning';
import CopyMeetingUrl from './CopyMeetingUrl';
const useStyles = makeStyles()((theme) => {
    return {
        // 11sight custom added START
        contentContainer: {
            position: 'absolute',
            display: 'flex',
            width: '100%',
            height: '100%',
            flexDirection: 'column',
            justifyContent: 'flex-end',
            alignItems: 'center',
        },
        // 11sight custom added END
        container: {
            height: '100%',
            position: 'absolute',
            inset: '0 0 0 0',
            display: 'flex',
            backgroundColor: '#000',
            zIndex: 252,
            '@media (max-width: 720px)': {
                flexDirection: 'column-reverse',
            },
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            flexShrink: 0,
            boxSizing: 'border-box',
            margin: '0 48px',
            padding: '24px 0 16px',
            position: 'relative',
            width: 'fit-content',
            zIndex: 252,
            '@media (max-width: 720px)': {
                height: 'auto',
                margin: '0 auto',
            },
            // mobile phone landscape
            '@media (max-width: 420px)': {
                padding: '16px 16px 0 16px',
                width: '100%',
            },
            '@media (max-width: 400px)': {
                padding: '16px',
            },
        },
        contentControls: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            margin: 'auto',
            width: '100%',
        },
        title: {
            color: '#fff',
            lineHeight: '32px',
            fontSize: 24,
            marginBottom: 16,
            textAlign: 'center',
        },
        roomName: {
            ...withPixelLineHeight(theme.typography.heading5),
            color: theme.palette.text01,
            marginBottom: theme.spacing(4),
            overflow: 'hidden',
            textAlign: 'center',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            width: '100%',
        },
    };
});
const PreMeetingScreen = ({ _buttons, _premeetingBackground, _roomName, children, className, showDeviceStatus, showUnsafeRoomWarning, skipPrejoinButton, title, videoMuted, videoTrack, }) => {
    const { classes } = useStyles();
    const style = _premeetingBackground
        ? {
            background: _premeetingBackground,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
        }
        : {};
    // 11sight added line
    const willAvatarBeVideo = !videoMuted && videoTrack;
    return (React.createElement("div", { className: clsx('premeeting-screen', classes.container, className) },
        React.createElement("div", { className: classes.contentContainer, style: style },
            React.createElement("div", { className: classes.content },
                React.createElement(ConnectionStatus, null),
                React.createElement("div", { className: classes.contentControls },
                    React.createElement("div", null,
                        React.createElement("h1", { className: classes.title }, title),
                        React.createElement(CopyMeetingUrl, null),
                        children,
                        _buttons.length && React.createElement(Toolbox, { toolbarButtons: _buttons, addBackground: false }),
                        skipPrejoinButton),
                    showUnsafeRoomWarning && React.createElement(UnsafeRoomWarning, null),
                    showDeviceStatus && React.createElement(DeviceStatus, null)))),
        willAvatarBeVideo && React.createElement(Preview, { videoMuted: videoMuted, videoTrack: videoTrack })));
};
/**
 * Maps (parts of) the redux state to the React {@code Component} props.
 *
 * @param {Object} state - The redux state.
 * @param {Object} ownProps - The props passed to the component.
 * @returns {Object}
 */
function mapStateToProps(state, ownProps) {
    const { hiddenPremeetingButtons, hideConferenceSubject } = state['features/base/config'];
    const toolbarButtons = getToolbarButtons(state);
    const premeetingButtons = (ownProps.thirdParty ? THIRD_PARTY_PREJOIN_BUTTONS : PREMEETING_BUTTONS).filter((b) => !(hiddenPremeetingButtons || []).includes(b));
    const { premeetingBackground } = state['features/dynamic-branding'];
    return {
        // For keeping backwards compat.: if we pass an empty hiddenPremeetingButtons
        // array through external api, we have all prejoin buttons present on premeeting
        // screen regardless of passed values into toolbarButtons config overwrite.
        // If hiddenPremeetingButtons is missing, we hide the buttons according to
        // toolbarButtons config overwrite.
        _buttons: hiddenPremeetingButtons
            ? premeetingButtons
            : premeetingButtons.filter((b) => isToolbarButtonEnabled(b, toolbarButtons)),
        _premeetingBackground: premeetingBackground,
        _roomName: (hideConferenceSubject ? undefined : getConferenceName(state)) ?? '',
    };
}
export default connect(mapStateToProps)(PreMeetingScreen);
